import firebase from 'firebase/app';
//import 'firebase/auth';
//import 'firebase/firestore';
//import 'firebase/storage';
//import 'firebase/messaging'
//import 'firebase/functions'
import 'firebase/analytics';

var config = {
    apiKey: "AIzaSyDV4EbAJsQ1VkUvioMC8aPU65xcxqG_Rio",
    authDomain: "prod-sensorium.firebaseapp.com",
    databaseURL: "https://prod-sensorium.firebaseio.com",
    projectId: "prod-sensorium",
    storageBucket: "prod-sensorium.appspot.com",
    messagingSenderId: "1039274847891",
    appId: "1:1039274847891:web:6b317e868a83fa4a44a766",
    measurementId: "G-GXRWQS1BT7"
};
var fire = firebase.initializeApp(config);
//firebase.analytics();
export default fire;

/*const db = fire.firestore();
const settings = { timestampsInSnapshots: true};
db.settings(settings);

export {firebase, db};*/